import { RECEIVE_FEATURES } from '../actions';

export default (state = {}, action) => {
  switch (action.type) {
    case RECEIVE_FEATURES:
      return {
        ...state,
        ...action.data,
      };
    default:
      return state;
  }
};
